import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
// const head = { "Content-Type": "multipart/form-data" };

// const instance2 = axios.create({
//   baseURL: "http://localhost:3333",
//   headers: { ...authHeader(), ...head },
// });
class ApproveService {
  // newPass(id, req) {
  //   return instance.put("/users/new", req, {
  //     params: {
  //       id: id,
  //     },
  //   });
  // }
  //   updateUserprofile(id, req) {
  //     return instance.put("/users/profile/" + id, req);
  //   }
  //   getUserprofile(id) {
  //     return instance.get("/users/profile/" + id);
  //   }
  getMember(reg_id) {
    return instance.get("/reg_member/" + reg_id);
  }
  getDirect(reg_id) {
    return instance.get("/reg_direct/" + reg_id);
  }
  getMaster(reg_id) {
    return instance.get("/reg_master/" + reg_id);
  }
  getDeed(reg_id) {
    return instance.get("/reg_deed/" + reg_id);
  }
  approveStatus(body) {
    return instance.post("/reg_approve", body);
  }
  reSign(body) {
    return instance.post("/resign", body);
  }
  approveMasterStatus(body) {
    return instance.post("/reg_master_approve", body);
  }
  getContract(body) {
    return instance.post("/getcontract", body);
  }
  //   getDirect(reg_id) {
  //     return instance.get("/reg_direct/" + reg_id);
  //   }
  //   getMaster(reg_id) {
  //     return instance.get("/reg_member/" + reg_id);
  //   }
}

export default new ApproveService();
